import cc from "classcat"

const H5 = ({ children, className = "", textAlign = "left" }) => {
  return (
    <h5
      className={cc([
        "my-0 text-lg font-medium leading-6 text-zinc-900",
        className,
        {
          "text-left": textAlign === "left",
          "mx-auto text-center": textAlign === "center",
          "text-right": textAlign === "right",
        },
      ])}
    >
      {children}
    </h5>
  )
}

export default H5
